<template>
<div class="chapter">
<div class="inner_page">
<section id="ded" title="Dedication">
<p class="fm_head"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><a href="#/text/9780063075771_Contents#rded">Dedication</a></span></p>
<p class="ded_pb_1">F<span class="make_smallcaps">OR</span></p>
<p class="ded_pb_1">H<span class="make_smallcaps">AROLD</span> R<span class="make_smallcaps">OSS</span></p>
<p class="ded_pb_1"><i>with increasing admiration,</i></p>
<p class="ded_pb_1"><i>wonder and affection</i></p>
<div class="fig_40"><img alt="image" src="images/f00ii-01.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063075771_Dedication.vue?1a950332